import { render, staticRenderFns } from "./IndustryAnalysis.vue?vue&type=template&id=5b65f786&scoped=true&"
import script from "./IndustryAnalysis.vue?vue&type=script&lang=ts&"
export * from "./IndustryAnalysis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b65f786",
  null
  
)

export default component.exports